<template class="is-black">
  <section>
    <Header class="hero is-black is-fullheight" />
    <VideoCTA />
    <Programs />
    <SpecialPrograms />
    <WhatsappCTA />
    <Trainers />
    <!-- <Awards /> -->
    <ProgramsHorizontal />
    <News />
    <JoinUs />
    <!-- <BookTrialForm /> -->
    <!-- <Footer /> -->
  </section>
</template>

<script>
import Header from "../components/Header/Header";
import VideoCTA from "../components/VideoCTA";
import Programs from "../components/Programs";
import SpecialPrograms from "../components/SpecialPrograms";
import Trainers from "../components/Trainers";
import WhatsappCTA from "../components/WhatsappCTA";
import ProgramsHorizontal from "../components/ProgramsHorizontal";
// import Awards from "../components/Awards";
import News from "../views/News";
import JoinUs from "../components/JoinUs";
// import BookTrialForm from "../components/BookTrial/BookTrialForm";
// import Footer from "../components/Footer";

export default {
  components: {
    Header,
    VideoCTA,
    Programs,
    SpecialPrograms,
    Trainers,
    WhatsappCTA,
    ProgramsHorizontal,
    // Awards,
    News,
    JoinUs
    // BookTrialForm
    // Footer
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  created() {
    let wistia_1 = document.createElement("script");
    wistia_1.setAttribute(
      "src",
      "//fast.wistia.com/embed/medias/oip8hm0dv7.jsonp"
    );
    document.head.appendChild(wistia_1);
    let wistia_2 = document.createElement("script");
    wistia_2.setAttribute("src", "//fast.wistia.com/assets/external/E-v1.js");
    document.head.appendChild(wistia_2);
  }
};
</script>
